export default __webpack_public_path__ + "static/media/home.1bc72445.jpg";